<template>
  <div class="input-dropdown touch">
    <div v-if="icon" class="input-dropdown__icon">
      <fa :icon="icon" fixed-width />
    </div>
    <div v-if="label" class="input-dropdown__label">
      {{ label }}
    </div>
    <div class="input-dropdown__reveal input-dropdown__button touch input-dropdown__button--active" @click="isActive = !isActive">{{ value ? value : language.code === 'en' ? 'All' : 'جَميع' }} 
      <fa 
        class="input-dropdown__button-icon"
        :class="{ 'input-dropdown__button-icon--active' : isActive }"
        icon="chevron-down"
      />
    </div>
    <transition name="fast-fade">
      <div v-show="isActive" class="input-dropdown__buttons">
    
        <div class="input-dropdown__heading">{{ label }}</div>
        <div 
          class="input-dropdown__button touch"
          :class="{ 'input-dropdown__button--active': isSelectionActive(selection) }"
          v-for="selection in selections"
          :key="selectionKey(selection)"
          @click="selectOption(selection)"
        >
          {{ selection.label[language.code] || selection.label.en }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: [ 'icon', 'label', 'selections', 'value'],

  data () {
    return {
      isActive: false,
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),
  },

  methods: {
    normalizeValue (value) {
      if (typeof value === 'undefined' || value === null) return ''
      return value.toString().trim().toLowerCase()
    },

    selectionKey (selection) {
      if (!selection || typeof selection.value === 'undefined' || selection.value === null) return 'empty'
      if (typeof selection.value === 'object') {
        return selection.value.en || selection.value.ar || JSON.stringify(selection.value)
      }
      return selection.value.toString()
    },

    isSelectionActive (selection) {
      if (!selection) return false

      if (typeof selection.value === 'boolean') {
        return selection.value === this.value
      }

      const normalizedCurrentValue = this.normalizeValue(this.value)
      if (!normalizedCurrentValue) return false

      if (typeof selection.value === 'object' && selection.value !== null) {
        return [selection.value.en, selection.value.ar]
          .filter(Boolean)
          .some(candidate => this.normalizeValue(candidate) === normalizedCurrentValue)
      }

      return this.normalizeValue(selection.value) === normalizedCurrentValue
    },

    selectOption (selection) {
      if (typeof selection.value === 'boolean') {
        this.$emit('input', selection.value)
      } else if (typeof selection.value === 'object' && selection.value !== null) {
        this.$emit('input', selection.value[this.language.code] || selection.value.en || selection.value.ar || false)
      } else {
        this.$emit('input', selection.value)
      }

      this.isActive = false
    }
  }
}
</script>
<style lang="scss">
.input-dropdown {
  position: relative;

  &__icon {
    font-size: 1.2rem;

    svg {
      margin-right: 1rem;
    }
  }

  &__label {
    display: block;
    font-size: 1.5rem;
    margin-bottom: 0.5em;
  }

  &__heading {
    color: #000;
    font-size: 1.5rem;
    margin-bottom: 0.5em;
  }

  &__buttons {
    align-items: flex-start;
    background: #fff;
    border-radius: .7rem;
    bottom: 2.5rem;
    display: flex;
    flex-direction: column;
    left: 0;
    margin-bottom: 1rem;
    max-height: 40rem;
     overflow: scroll;
    padding: 1rem;
    position: absolute;
    right: 0;
    z-index: 10;
  }

  &__button {
    align-items: center;
    background: #333;
    border: 0.2rem solid #000;
    border-radius: 0.7rem;
    color: #fff;
    display: flex;
    font-size: 1.2rem;
    justify-content: space-between;
    padding: 0.3em 0.5em;
    pointer-events: all;
    margin-bottom: .5rem;
    min-width: 3rem;
    // opacity: 0.6;
    text-align: left;
    text-transform: capitalize;
    transition: background-color 0.15s ease-in;
    width: 100%;

    &:last-child {
      margin: 0;
    }

    &--active {
      background: #fff;
      border: 0.2rem solid #000;
      color: #000;
      opacity: 1;
    }
  }

  &__button-icon {
    // margin-left: auto;
    transform: rotate(180deg) !important;
    transition: transform 200ms ease !important;

    &--active {
      transform: rotate(0) !important;
    }
  }
}
</style>
